export default function getCategory(data) {
  return data.categories.map((elem) => elem.values).flat() ?? [];
}
